<template>
  <div>
    <h1 style="margin: 10px">Skill {{$store.state.skills[$route.params.id].title}} Business Availability for {{$route.params.city}}</h1>
    <table style="margin: 0 auto;margin-bottom: 20px">
      <tr>
        <th>City</th>
        <th>City</th>
        <th>Radius</th>
        <th>Name</th>
        <th>Price</th>
        <th>Completed</th>
        <th>Status</th>
      </tr>
      <tr v-for="pro in pros" v-bind:key="pro.id">
        <td style="text-align: left">{{ pro.serviceArea.code }}</td>
        <td style="text-align: left">{{ pro.serviceArea.text }}</td>
        <td style="text-align: left">{{ pro.serviceArea.radius / 1000 }}km</td>
        <td style="text-align: left"><router-link :to="{ name: 'userProfile', params: { id: pro.id } }">{{pro.firstName + ' ' + pro.lastName}}</router-link></td>
        <td>{{ pro.skillSettings && pro.skillSettings[skillId] ? Number(pro.skillSettings[skillId].rate / 100 / 0.8).toFixed(2) : '?' }}</td>
        <td>{{ pro.tasksCompleted }}</td>
        <td>{{ pro.ordersDisabled ? 'DISABLED' : '' }}:{{ pro.proType === 'business' && pro.businessSkills && pro.businessSkills.indexOf(skillId) !== -1 ? 'business' : '' }}{{!pro.availabilityConfig && pro.proType === 'business' ? ':NOCAL' : ''}}</td>
      </tr>
    </table>
    <div v-if="selectedDate.startTime">{{new Date(selectedDate.startTime)}}</div>
    <div
      v-for="pro in selectedDate.pros"
      v-bind:key="pro.id"
      style="margin: 20px"
    >
      <div>{{pro.firstName}} {{pro.lastName}} {{pro.phoneNumber}} {{pro.id}} </div>
    </div>
    <div style="display:flex; background-color: white; overflow-x: scroll">
      <DatePicker :availabilitySlots="dates" v-if="dates" @save="selectDate" />
    </div>
    <table style="margin: 0 auto;margin-top: 20px">
      <tr>
        <th>City</th>
        <th>City</th>
        <th>Radius</th>
        <th>Name</th>
        <th>Price</th>
        <th>Completed</th>
        <th>Status</th>
      </tr>
      <tr v-for="pro in b2cPros" v-bind:key="pro.id">
        <td style="text-align: left">{{ pro.serviceArea.code }}</td>
        <td style="text-align: left">{{ pro.serviceArea.text }}</td>
        <td style="text-align: left">{{ pro.serviceArea.radius / 1000 }}km</td>
        <td style="text-align: left"><router-link :to="{ name: 'userProfile', params: { id: pro.id } }">{{pro.firstName + ' ' + pro.lastName}}</router-link></td>
        <td>{{ pro.skillSettings && pro.skillSettings[skillId] ? Number(pro.skillSettings[skillId].rate / 100 / 0.8).toFixed(2) : '?' }}</td>
        <td>{{ pro.tasksCompleted }}</td>
        <td>{{ pro.ordersDisabled ? 'DISABLED' : '' }}:{{ pro.proType === 'business' && pro.businessSkills && pro.businessSkills.indexOf(skillId) !== -1 ? 'business' : '' }}{{!pro.availabilityConfig && pro.proType === 'business' ? ':NOCAL' : ''}}</td>
      </tr>
    </table>
  </div>
</template>

<style scoped lang="less">
 
table {
  td {
    border: 1px solid #999;
    border-collapse: collapse;
    margin: 0;
    padding: 10px;
  }
}
</style>

<script>
import api from "../services/api";
import DatePicker from '../components/DatePicker.vue';
import {cities, geo} from "discontract-js-shared";

export default {
  name: "home",
  data: function () {
    return {
      dates: null,
      selectedDate: {pros: []},
      pros: [],
      b2cPros: [],
      skillId: ''
    };
  },
  components: {
    DatePicker
  },
  methods: {
    async selectDate(date) {
      const pros = await api.getUsersByIds(date.prosAvailable);
      date.pros = pros;
      this.selectedDate = date;
    }
  },
  async created() {
    const city = cities.reduce((prev, next) => next.code === this.$route.params.city ? next : prev, null);
    const dates = await api.getSkillDates(this.$route.params.id, {
      location: city.location,
      country: city.country
    });
    this.dates = dates.dates;
    const skillId = this.$route.params.id;
    this.skillId = skillId;
    // console.log(this.$route.params);
    const users = await api.getPros();
    users.forEach(pro => {
      // console.log(pro.businessSkills, s.id);
      if (pro.verified) {
        const serviceArea = pro.serviceArea;
        const distance = geo.getDistanceFromLatLonInKm(
          serviceArea.latitude,
          serviceArea.longitude,
          city.location.lat,
          city.location.lng,
        );
        if (distance <= serviceArea.radius / 1000 && (pro.serviceArea.country || 'LT') === city.country) {
          if ((pro.businessSkills || []).includes(skillId) && pro.proType === 'business') {
            this.pros.push(pro);
          } else if ((pro.skills || []).includes(skillId)) {
            this.b2cPros.push(pro);
          }
        }
      }
    });
    this.pros = this.pros.sort((p1, p2) => {
      return p2.tasksCompleted - p1.tasksCompleted;
    });
    this.b2cPros = this.b2cPros.sort((p1, p2) => {
      return p2.tasksCompleted - p1.tasksCompleted;
    });
    this.$forceUpdate();
  },
}

</script>